<template>
  <div id="knowledge-base-page">
    <div class="knowledge-base-jumbotron">
      <div class="knowledge-base-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
        <h1 class="mb-1 text-white"><feather-icon icon="KeyIcon" class="w-5 h-5 mr-1"></feather-icon>eFactura</h1>
        <p class="text-white">This software section is securely protected with strong encryption, ensuring your data is
          safe.</p>
      </div>
    </div>
    <vx-card>
      <vs-alert color="warning" icon-pack="feather" icon="icon-alert-triangle" class="mb-4">
        <strong>Use Microsoft Edge.</strong> The connection to ANAF (logincert.anaf.ro) requires your qualified
        certificate: Edge presents it automatically and the login works on the first try.
        With Chrome, Firefox or Safari the certificate is often not offered and the connection fails.
        <br />
        If you are not on Edge, copy this address into Edge:
        <strong>https://xylo.codesinn.com/web/efacturalogin</strong>
      </vs-alert>

      {{ message }}
      
      <vs-button
        v-if="code"
        color="primary"
        type="border"
        @click="goto()"
      >
        Push Token!
      </vs-button>
    </vx-card>
  </div>
</template> 

<script>
import moduleBankList from "@/store/bank/moduleDataList.js";
import { Row } from "jspdf-autotable";

export default {
  data() {
    return {
      knowledgeBaseSearchQuery: '',
      connectAnaf: {},
      message: "Status: Recepting connection code from ANAF... Please wait...",
      code: null,
      token: null,
    }
  },
  computed: {
    filteredKB() {
      return this.kb.filter((item) => item.title.toLowerCase().includes(this.knowledgeBaseSearchQuery.toLowerCase()) || item.description.toLowerCase().includes(this.knowledgeBaseSearchQuery.toLowerCase()))
    }
  },
  methods: {
    goto() {
      const url = `https://xylo.codesinn.com/api/anaf/gettoken/d86f4d7f-65d3-413e-aed4-2ae3816d5145/${this.$route.query.code}`;
      window.location.href = url;
    },
    async connectWithAnaf() {
      this.$store
        .dispatch("BankList/manageAnafToken", this.code)
        .then(res => {
          this.$router.push("/efacturalogin");
        })
        .catch(err => {
          console.error(err);
        });
    },
    handleButtonClick(event, path) {
      if (event.ctrlKey || event.metaKey) {
        window.open(path, '_blank');
      } else {
        this.$router.push(path);
      }
    }
  },
  async created() {
    if (!moduleBankList.isRegistered) {
      this.$store.registerModule("BankList", moduleBankList);
      moduleBankList.isRegistered = true;
    }
    try {
      this.code = this.$route.query.code;
      setTimeout(() => {
        this.message = 'Status: ANAF code received: ' + this.code + '. Please wait, we are exchanging it for the TOKEN.'
      }, 6000);
      setTimeout(() => {
        this.message = 'Status: Exchange in progress... (Code to exchange:' + this.code + ')'
      }, 6000);
      setTimeout(() => {
        if (this.code) {
          this.connectWithAnaf()
        }
        else this.message = 'Status: An error occured. ANAF did not return any connection code. Please retry from Microsoft Edge and check that the certificate you select is the one used to connect to SPV ANAF.'
      }, 6000);
    }
    catch (error) {
      console.error("Error in component created hook:", error);
    }

  },
  components: {}
}
</script>

<style lang="scss">
.knowledge-base-jumbotron-content {
  background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
  background-size: cover;
  height: 250px;
}

.institution {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  transition: background-color 0.3s ease;
}

.institution:hover {
  background-color: #e6f7ff;
}

.institution img {
  margin-right: 15px;
  border-radius: 5px;
}

.institution-info {
  flex-grow: 1;
}
</style>
